import { createContext, type ReactNode } from "react";

/**
 * Lets a story draw the signed-in supplier's own mark where the portal's brand goes (docs/features/portal-sign-in
 * mock-ups: the header names who is signed in). Absent: the Pollards supplier-portal brand, as before. Mock-up phase:
 * the header reads it; the stories of the `home.*` and `account.*` cases provide it.
 */
export const SupplierBrandContext = createContext<ReactNode | null>(null);
